<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">{{ $t('buttons.addProductNatures') }}</strong>
                <strong v-else>{{ $t('buttons.editProductNatures') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>
                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="success"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody ref="add_container">
            <CRow>
              <CCol col="4">
                <CInput
                    :label="$t('components.natureName')"
                    :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                    v-model="name"
                    autocomplete="name"
                />
              </CCol>
<!--              <CCol col="3">-->
<!--                <CInput-->
<!--                    :label="$t('components.code')"-->

<!--                    type="number"-->
<!--                    v-model="code"-->

<!--                    horizontal-->
<!--                />-->

<!--              </CCol>-->
            </CRow>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow v-show="this.$route.path == '/dashboard/base/inventory-settings'">

      <CCol md="6">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.productNatures') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items"
                :fields="fields"
                @row-clicked="table_row_clicked"

                :items-per-page="10"
                hover
                border
                striped
                sorter
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.catTitle }}</p>

                </td>

              </template>

              <template #summary="{item}">

                <td>
                  <p >{{ item.summary }}</p>

                </td>

              </template>

              <template #code="{item}">

                <td>
                  <div>
                    {{ item.code }}
                  </div>
                </td>

              </template>

              <template #image="{item}">


                <td>
                  <CImg width="50px" height="50px" v-bind:src="get_image_file(item)"/>
                </td>

              </template>

              <template #operation="{item}">
                <td>
<!--                  <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                  <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      edit_name:'',
      confirm_delete_name: "confirm_nature" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      file: null,
      code: '',
      table_clicks_timer: null,
      table_clicks: 0,
      previewImage: '/img/placeholder.png',
      description: '',
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'title', label: this.$t('tables.name'), _style: 'width:20%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},
        {key: 'code', label: this.$t('tables.code'), _style: 'width:10%;'},
        // {key: 'image', label: this.$t('tables.image'), _style: 'width:20%;'},
        {key: 'operation', label: "",filter:false, _style: 'width:10%;'},
      ],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' ) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {

        backgroundColor: color

      }
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    edit_item(item) {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.edit_name = item.title;
      this.name = item.title;
      this.code = item.code;
      // this.description = this.items[item.row_id].summary;
      // this.previewImage = this.items[item.row_id].image;
      this.status_form = item.id;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.code = '';
      this.description = '';
      this.previewImage = '';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.$route.params.cat_id);


      axios.post('GetProductNatures', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddProductNature";
      } else {
        url = "EditProductNature";
        formData.append('Id', this.status_form)

      }

      formData.append('Title', this.name);
      formData.append('Code', this.code);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          self.status_form = 0;
          self.name = '';
          self.code = '';
          self.description = '';
          self.previewImage = '';
          self.get_lists();
          bus.$emit('close_add_base_modal', 'false');

        }

      })


          .catch(function (error) {
            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteProductNature";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
